import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appPrimaryButton]',
    standalone: false
})
export class PrimaryButtonDirective {
    @HostBinding('class') get classes(): string {
        return 'primary-button-uniform';
    }
}
